var _rect, _rect2, _rect3, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiPublicFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 38 23",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.987,
    y: 0.667,
    width: 5.347,
    height: 11.879,
    rx: 1,
    fill: "#A8FFF8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 7.556,
    width: 6.667,
    height: 6.667,
    rx: 3.333,
    fill: "#CBFF88"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.667,
    y: 14.667,
    width: 4.37,
    height: 4,
    rx: 2,
    fill: "#CBFF88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillOpacity: 0.15,
    d: "M12.083 2.963h11.954v7.481H12.083z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.863 2.333c.168 0 .303.136.303.303v10.606a.303.303 0 01-.303.303h-3.232v1.818a.304.304 0 01-.438.271l-4.179-2.089h-4.878a.303.303 0 01-.303-.303V2.636c0-.167.136-.303.303-.303h12.727zM13.44 12.939h4.647l.07.008a.303.303 0 01.066.024l3.803 1.902v-1.631c0-.167.136-.303.303-.303h3.232v-10H13.44v10z",
    fill: "#14454C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.732 6.272a.303.303 0 010 .606h-6.464a.303.303 0 010-.606h6.464zM22.732 9.1a.303.303 0 010 .607h-6.464a.303.303 0 010-.606h6.464z",
    fill: "#14454C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 0l.99 2.51L38 3.5l-2.51.99L34.5 7l-.99-2.51L31 3.5l2.51-.99L34.5 0zM3.5 16l.99 2.51L7 19.5l-2.51.99L3.5 23l-.99-2.51L0 19.5l2.51-.99L3.5 16z",
    fill: "#14D1C2"
  })));
}
export default __webpack_public_path__ + "fonts/ai-public-feedback-934d29523d2be61535f082c23139ce9f.svg";
export { SvgAiPublicFeedback as ReactComponent };